/* Evermark Mercantile — theme.js */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    initMobileMenu();
    initCartDrawer();
    initQtySelectors();
    initProductGallery();
    initVariantSwatches();
    initAddToCartForms();
  });

  /* -------- Mobile menu -------- */
  function initMobileMenu() {
    var toggle = document.querySelector("[data-menu-toggle]");
    var menu = document.querySelector("[data-mobile-menu]");
    if (!toggle || !menu) return;
    toggle.addEventListener("click", function () {
      menu.classList.toggle("is-open");
      document.body.classList.toggle("menu-open");
    });
  }

  /* -------- Cart drawer -------- */
  function initCartDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    var overlay = document.querySelector("[data-cart-overlay]");
    var openers = document.querySelectorAll("[data-cart-open]");
    var closers = document.querySelectorAll("[data-cart-close]");

    function open() {
      if (!drawer) return;
      drawer.classList.add("is-open");
      if (overlay) overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
      refreshCartDrawer();
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove("is-open");
      if (overlay) overlay.classList.remove("is-open");
      document.body.style.overflow = "";
    }

    openers.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        open();
      });
    });
    closers.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        close();
      });
    });
    if (overlay) overlay.addEventListener("click", close);

    window.EvermarkCart = { open: open, close: close, refresh: refreshCartDrawer };
  }

  function refreshCartDrawer() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var countEls = document.querySelectorAll("[data-cart-count]");
        countEls.forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? "flex" : "none";
        });
      })
      .catch(function () {});
  }

  /* -------- Quantity selectors -------- */
  function initQtySelectors() {
    document.querySelectorAll("[data-qty-selector]").forEach(function (wrap) {
      var input = wrap.querySelector("input");
      var minus = wrap.querySelector("[data-qty-minus]");
      var plus = wrap.querySelector("[data-qty-plus]");
      if (!input) return;
      if (minus) minus.addEventListener("click", function () {
        var val = Math.max(1, parseInt(input.value || "1", 10) - 1);
        input.value = val;
        input.dispatchEvent(new Event("change"));
      });
      if (plus) plus.addEventListener("click", function () {
        var val = parseInt(input.value || "1", 10) + 1;
        input.value = val;
        input.dispatchEvent(new Event("change"));
      });
    });
  }

  /* -------- Product gallery -------- */
  function initProductGallery() {
    document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-gallery-main]");
      var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          if (!main) return;
          main.src = thumb.dataset.full || thumb.src;
          thumbs.forEach(function (t) { t.classList.remove("active"); });
          thumb.classList.add("active");
        });
      });
    });
  }

  /* -------- Variant swatches (simple visual state; form still submits variant id) -------- */
  function initVariantSwatches() {
    document.querySelectorAll("[data-swatch-group]").forEach(function (group) {
      var swatches = group.querySelectorAll(".swatch");
      swatches.forEach(function (swatch) {
        swatch.addEventListener("click", function () {
          swatches.forEach(function (s) { s.classList.remove("selected"); });
          swatch.classList.add("selected");
          var hiddenInput = group.parentElement.querySelector("[data-option-input]");
          if (hiddenInput) hiddenInput.value = swatch.dataset.value;
        });
      });
    });
  }

  /* -------- Add to cart (AJAX) -------- */
  function initAddToCartForms() {
    document.querySelectorAll("[data-add-to-cart-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var button = form.querySelector("[type='submit']");
        var originalText = button ? button.textContent : "";
        if (button) {
          button.disabled = true;
          button.textContent = "Adding…";
        }
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(Object.fromEntries(new FormData(form)))
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (window.EvermarkCart) window.EvermarkCart.open();
          })
          .catch(function () {
            if (button) button.textContent = "Something went wrong";
          })
          .finally(function () {
            if (button) {
              button.disabled = false;
              button.textContent = originalText;
            }
          });
      });
    });
  }
})();
